export const AdTypes = {
  ResponsiveSearch: 'ResponsiveSearch',
  Responsive: 'Responsive',
  DynamicSearch: 'DynamicSearch',
};

export const AdTypeStrings = {
  [AdTypes.ResponsiveSearch]: _TL_('Responsive Search ad'),
  [AdTypes.Responsive]: _TL_('Multimedia ad'),
  [AdTypes.DynamicSearch]: _TL_('Dynamic Search ad'),
};

export const AdTypePluralStrings = {
  [AdTypes.ResponsiveSearch]: _TL_('Responsive Search ads'),
  [AdTypes.Responsive]: _TL_('Multimedia ads'),
  [AdTypes.DynamicSearch]: _TL_('Dynamic Search ads'),
};

export const AdTypeMaxCount = {
  [AdTypes.ResponsiveSearch]: 3,
  [AdTypes.Responsive]: 5,
  [AdTypes.DynamicSearch]: 100,
};

export const StandardAdTypes = [AdTypes.ResponsiveSearch, AdTypes.Responsive];
export const DynamicAdTypes = [AdTypes.DynamicSearch];
